import { defineElement, TemplateElement, html } from '@webtides/element-js';
import { define, SliderElementEvents } from '@webtides/slider-element';

class ComparisonHeader extends TemplateElement {
    slider = null;

    constructor() {
        super({ deferUpdate: true });
        this.slider = document.getElementById('comparisonSlider');
        //index columns
        this.$cols = Array.from(this.slider.querySelectorAll('[data-column-title]'));
    }

    connected() {
        // TOOD handle NaN state provided by SLIDER_RUN event
        this.slider.addEventListener(SliderElementEvents.SLIDER_RUN, e => {
            this.current = e.detail;
        });
        this.slider.addEventListener(SliderElementEvents.SLIDER_RESIZE, e => {
            this.onCurrent();
            this.requestUpdate();
        });
        // init values
        this.onCurrent();
        this.requestUpdate();
    }

    properties() {
        return {
            label: 'Produkt',
            labelPrev: 'Zurück',
            labelNext: 'Weiter',
            current: 0,
            count: 0,
        };
    }

    events() {
        return {
            '[ref=next]': {
                click: ev => {
                    ev.preventDefault();
                    this.slider.next();
                },
            },
            '[ref=prev]': {
                click: ev => {
                    ev.preventDefault();
                    this.slider.previous();
                },
            },
        };
    }

    watch() {
        return {
            current: () => this.onCurrent(),
        };
    }

    onCurrent() {
        const current = this.$cols[this.current];
        this.currentTitle = current.dataset.columnTitle;
        this.visibleCount = Math.round(this.slider.offsetWidth / current.offsetWidth);
    }

    isPrevDisabled() {
        const scroller = this.slider?.$refs?.scroller ?? null;
        if (!scroller) {
            return false;
        }
        const reachedStart = this.current === 0;
        return reachedStart || !((this.slider?.canSlide ?? false) && (this.slider?.canSlideLeft ?? false));
    }

    isNextDisabled() {
        const scroller = this.slider?.$refs?.scroller ?? null;
        if (!scroller) {
            return false;
        }

        const reachedEnd = this.current + this.visibleCount >= this.count;
        return reachedEnd || !((this.slider?.canSlide ?? false) && (this.slider?.canSlideRight ?? false));
    }

    templateLabel() {
        if (this.visibleCount === 1) {
            return html`<div><span class="font-bold">${this.label}:</span> ${this.current + 1}/${this.count}</div>`;
        } else {
            const from = Math.min(this.current, parseInt(this.$cols.length - this.visibleCount));
            const to = Math.min(parseInt(this.current + this.visibleCount), this.$cols.length);
            return html` <div>
                <span class="font-bold">${this.label}:</span> ${from + 1} - ${to} von ${this.count}
            </div>`;
        }
    }

    template() {
        if (!this.slider?.canSlide ?? false) {
            return null;
        }

        return html`<div class="flex items-center">
            <button ref="prev" class="btn btn-dark" ?disabled="${this.isPrevDisabled()}">
                <svg-icon name="chevron-left"></svg-icon>
                <span class="hidden md:block text-sm sm:text-base">${this.labelPrev}</span>
            </button>
            <div class="flex flex-1 flex-col justify-center items-center">${this.templateLabel()}</div>
            <button ref="next" class="btn btn-dark" ?disabled="${this.isNextDisabled()}">
                <span class="text-sm sm:text-base hidden md:block ">${this.labelNext}</span>
                <svg-icon name="chevron-right"></svg-icon>
            </button>
        </div>`;
    }
}

defineElement('comparison-header', ComparisonHeader);
